// Traduções da planilha das listas do Mapa, coletadas por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'mapa.excel.dica': 'Baixa a lista como está na tela, com os filtros aplicados e todas as colunas.',
    'mapa.excel.dicaVazio': 'Nenhuma linha na lista para baixar.',
    'mapa.excel.noStatusDesde': 'No status desde',
    'mapa.excel.tempoJornada': 'Tempo de jornada',
    'mapa.excel.velocidade': 'Velocidade km/h',
    'mapa.excel.temperatura': 'Temperatura °C',
    'mapa.excel.latitude': 'Latitude',
    'mapa.excel.longitude': 'Longitude',
    'mapa.excel.frente': 'Frente',
    'mapa.excel.codigo': 'Código',
  },
  en: {
    'mapa.excel.dica': 'Downloads the list as shown, with the filters applied and every column.',
    'mapa.excel.dicaVazio': 'No rows in the list to download.',
    'mapa.excel.noStatusDesde': 'In status since',
    'mapa.excel.tempoJornada': 'Shift time',
    'mapa.excel.velocidade': 'Speed km/h',
    'mapa.excel.temperatura': 'Temperature °C',
    'mapa.excel.latitude': 'Latitude',
    'mapa.excel.longitude': 'Longitude',
    'mapa.excel.frente': 'Work front',
    'mapa.excel.codigo': 'Code',
  },
  es: {
    'mapa.excel.dica': 'Descarga la lista como está en pantalla, con los filtros aplicados y todas las columnas.',
    'mapa.excel.dicaVazio': 'Ninguna fila en la lista para descargar.',
    'mapa.excel.noStatusDesde': 'En el estado desde',
    'mapa.excel.tempoJornada': 'Tiempo de jornada',
    'mapa.excel.velocidade': 'Velocidad km/h',
    'mapa.excel.temperatura': 'Temperatura °C',
    'mapa.excel.latitude': 'Latitud',
    'mapa.excel.longitude': 'Longitud',
    'mapa.excel.frente': 'Frente',
    'mapa.excel.codigo': 'Código',
  },
}
